import { Component, OnInit, Input } from '@angular/core'
import { QuoteReviewService } from '../../services/quote-review.service'
import { Observable, of } from 'rxjs'
import { User, AuthService } from '@spartacus/core'
import { QuoteDataService } from '../../../quote-checkout/services/quote-data.service'
import { QuoteCheckoutService } from '../../../quote-checkout/services/quote-checkout.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { Router } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,
  selector: 'vs-address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.scss'],
})
export class AddressDetailsComponent implements OnInit {
  isLoggedinUser = false
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  cartData: any
  cartData$: Observable<any>
  productData: any
  reviewData: any
  @Input() soldToAddress: any
  @Input() shipToAddress: any
  @Input() endUserAddress: any

  constructor(
    private quoteDataService: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,

    private router: Router,
    private quoteReviewService: QuoteReviewService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    this.getCheckOutCartData()
    // this.reviewData = this.quoteReviewService.reviewData;
    // this.soldToAddress = this.reviewData.billToAddress;
    // this.shipToAddress = this.reviewData.deliveryAddress;
    // this.endUserAddress = this.reviewData.endUserAddress;
  }
  // Get cart details
  getCheckOutCartData() {
    if (this.userType === 'current') {
      this.cartId = sessionStorage.getItem('cartId-current')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-current')
    }
    if (this.userType === 'anonymous') {
      this.cartId = sessionStorage.getItem('cartId-anonymous')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-anonymous')
    }
    this.cartData$ = this.quoteService.getCart(this.cartId, this.userType)
    this.cartData$.subscribe(
      (data: any) => {
        this.cartLoaded = true
        this.cartData = data
        this.productData = data.entries
      },
      (error) => {}
    )
  }
}
